module.exports = __webpack_public_path__ + "img/filter-right.3ce9d38d.svg";